import * as React from 'react';
import styles from './style.module.scss';
import { ToolDialog, ToolDialogOpenDirection } from '@/components/tool-dialog';
import Editor from "@monaco-editor/react";
import * as monaco from 'monaco-editor/esm/vs/editor/editor.api';
import { text2xml } from '@/svgcanvas/utilities';
import { NS } from '@/common/namespaces';
import SvgEditService from '@/services/svg-edit-service';
import ColoursService from '@/services/colours-service';
import DesignerService from "@/services/designer-service";

interface State {
    svgText: string;
    validSvg: boolean;
}

const monacoOptions: monaco.editor.IStandaloneEditorConstructionOptions = {
    minimap: {
        enabled: false,
    }
}

export class SvgSourceEditor extends React.Component<{}, State> {
    private getDefaultState = () => {
        const state: State = {
            svgText: "",
            validSvg: false,
        };

        return state;
    }

    state = this.getDefaultState();

    public svgEditService = SvgEditService.Get(this);
    public designerService = DesignerService.Get(this);
    private colourService = ColoursService.Get(this);

    private dialog: React.RefObject<ToolDialog> = React.createRef();

    public componentWillUnmount() {
        this.svgEditService.UnregisterComponent(this);
        this.designerService.UnregisterComponent(this);
        this.colourService.UnregisterComponent(this);
    }

    public openToolDialog = (relativeTo: HTMLElement) => {
        this.dialog.current.open(relativeTo, ToolDialogOpenDirection.Right);
        this.setState({
            svgText: this.svgEditService.canvas.getSvgString(),
            validSvg: true,
        });
    }

    private onChange(value, event) {
        let validSvg = false;

        try {
            const parsed = text2xml(value);
            validSvg = parsed.firstElementChild && parsed.firstElementChild.namespaceURI === NS.SVG;
        } catch {
            // Ignore errors
        }

        this.setState({
            svgText: value,
            validSvg
        });
    }

    private onSave() {
        this.svgEditService.canvas.setSvgString(this.state.svgText, false);
        this.dialog.current.close();
        this.setState({ svgText: "" });
    }

    private onCancel() {
        this.dialog.current.close();
        this.setState({ svgText: "" });
    }

    private handleEditorWillMount = (monaco) => {
    }

    public render() {
        const darkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
        const editorTheme = darkMode ? "vs-dark" : "light";

        return (
            <ToolDialog ref={this.dialog} id="pd-svgeditor" title="Svg Editor" classes={styles.dialog}>
                <div className={styles.container}>
                    <h1>SVG Source Editor</h1>

                    <div>
                        <p>Use this tool to edit the raw SVG for this artwork. <strong>Note:</strong> This tool is for advanced users.</p>
                    </div>

                    <div className={styles.editorContainer}>
                        <Editor defaultLanguage="xml" options={monacoOptions} beforeMount={this.handleEditorWillMount} theme={editorTheme}
                            defaultValue={this.state.svgText} value={this.state.svgText} onChange={(v, e) => this.onChange(v, e)} />
                    </div>

                    <div className={styles.buttonList}>
                        {!this.state.validSvg && (
                            <div className="alert alert-warning">There is an error in your SVG. Make sure it's valid XML before saving.</div>
                        )}
                        <button type="button" className="btn btn-primary" onClick={() => this.onSave()} disabled={!this.state.validSvg}>Save Changes</button>
                        <button type="button" className="btn btn-secondary" onClick={() => this.onCancel()}>Cancel</button>
                    </div>
                </div>
            </ToolDialog>
        );
    }
}
